import { render, staticRenderFns } from "./BannerGuidy.vue?vue&type=template&id=d0d080ae&scoped=true"
import script from "./BannerGuidy.vue?vue&type=script&lang=js"
export * from "./BannerGuidy.vue?vue&type=script&lang=js"
import style0 from "./BannerGuidy.vue?vue&type=style&index=0&id=d0d080ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d080ae",
  null
  
)

export default component.exports